module.exports = __webpack_public_path__ + "img/09@2x.432580e9.png";